module.exports = "/images/terraEmpresas.png?3a2b0d2dedce1dabb50f5975630a4d3c";